
    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import { IBookingProfileVM } from "@/model/Api/VM/BookingProfileVM";
    import { Prop } from "vue-property-decorator";

    @Component({
        components: {
            ApiButton
        }
    })

    export default class BookingProfileAddModal extends Vue {

        //
        // -- properties
        //

        roomDefault: number = 0;
        @Prop({}) private bookingProfiles !: Array<IBookingProfileVM>;
        isDisabled: boolean = false;

        //
        // -- methods
        //

        show(isDisabled: boolean) {
            this.isDisabled = isDisabled;
            this.$bvModal.show("bookingProfileModal");
        }

        cancel() {
            this.$bvModal.hide("bookingProfileModal");
        }

        async save() {
            this.$emit("saveProfile");
        }

        setAllRoomsToDefault() {
            if (this.roomDefault < 0) {
                return;
            }

            this.bookingProfiles.forEach(p => {
                if (p.canEdit) {
                    p.noOfRooms = this.roomDefault;
                }
            });
        }
    }

